import { reatomAsync, withDataAtom } from "@reatom/async";
import { PaymentSubscribeRequestDto } from "definitions/poizon-bff";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";

import { RateCardProps } from "../../components";
import { rates } from "../../RatesWidget.constants";

interface RateWithMeta extends RateCardProps {
  meta: PaymentSubscribeRequestDto;
}

const hasMeta = (rate: RateCardProps): rate is RateWithMeta =>
  rate.meta !== undefined;

const ratesWithMeta = rates.filter(hasMeta);

export const getRatesPricesRequest = reatomAsync(async () => {
  const results = await Promise.allSettled(
    ratesWithMeta.map((rate) =>
      API.subscribeApi.subscribeControllerCalculatePrice({
        type: rate.meta.type,
        rps: rate.meta.rps,
        requestCount: rate.meta.req ?? rate.meta.rps * 60 * 60 * 24 * 30,
        withExport: rate.meta.withExport,
      }),
    ),
  );

  return ratesWithMeta.reduce<Record<string, number>>((acc, rate, index) => {
    const result = results[index];
    if (result.status === "fulfilled") {
      acc[rate.type] = result.value.data.price;
    }
    return acc;
  }, {});
}, "getRatesPricesRequest").pipe(withDataAtom(null), withIsLoadingAtom());
